import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import moment from 'moment';

import './style.css';

// eslint-disable-next-line react/prefer-stateless-function
class BottomBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { compareDates: false }; // Implementation ready to be able to compare
    // diferent products at diferent times, just remove condition if need it
    this.onChangeMonth = this.onChangeMonth.bind(this);
    this.onChangeComparingMonth = this.onChangeComparingMonth.bind(this);
    this.onChangeDay = this.onChangeDay.bind(this);
    this.onChangeComparingDay = this.onChangeComparingDay.bind(this);
    this.onChangeHour = this.onChangeHour.bind(this);
    this.onChangeComparingHour = this.onChangeComparingHour.bind(this);
    this.onClickCompare = this.onClickCompare.bind(this);
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
  }

  /**
   * Event hander executed when the user changes the month
   * @param {{ label: string, value: number }} month Selected month
   */
  onChangeMonth(month) {
    const { setMonth } = this.props;
    setMonth(month);
  }

  /**
   * Event hander executed when the user changes the comparing month
   * @param {{ label: string, value: number }} month Selected month
   */
  onChangeComparingMonth(month) {
    const { setComparingMonth } = this.props;
    setComparingMonth(month);
  }

  /**
   * Event hander executed when the user changes the day
   * @param {{ label: string, value: number }} day Selected day
   */
  onChangeDay(day) {
    const { setDay } = this.props;
    setDay(day);
  }

  /**
   * Event hander executed when the user changes the comparing day
   * @param {{ label: string, value: number }} day Selected day
   */
  onChangeComparingDay(day) {
    const { setComparingDay } = this.props;
    setComparingDay(day);
  }

  /**
   * Event hander executed when the user changes the hour
   * @param {{ label: string, value: number }} hour Selected hour
   */
  onChangeHour(hour) {
    const { setHour } = this.props;
    setHour(hour);
  }

  /**
   * Event hander executed when the user changes the comparing hour
   * @param {{ label: string, value: number }} hour Selected hour
   */
  onChangeComparingHour(hour) {
    const { setComparingHour } = this.props;
    setComparingHour(hour);
  }

  /**
   * Event hander executed when the user changes the language
   * @param {{ label: string, value: string }} language Selected language
   */
  onChangeLanguage(language) {
    const { setLanguage } = this.props;
    setLanguage(language);
  }

  /**
   * Event hander executed when the user clicks the compare button
   */
  onClickCompare() {
    const { toggleComparing } = this.props;
    toggleComparing(true);
  }

  render() {
    const {
      months,
      days,
      hours,
      selectedMonth,
      selectedDay,
      selectedHour,
      selectedDate,
      selectedComparingDate,
      comparingMonths,
      comparingDays,
      comparingHours,
      timezone,
      // selectedComparingYear,
      selectedComparingMonth,
      selectedComparingDay,
      selectedComparingHour,
      comparing,
    } = this.props;

    const { compareDates } = this.state;

    // Selected date values
    if (!selectedMonth || !selectedDay || !selectedHour) return null;

    const selectedTimezoneHour = {
      value: selectedHour.value,
      label: moment
        .utc(selectedDate)
        .hour(selectedHour.value)
        .utcOffset(timezone)
        .format('HH:mm'),
    };

    const selectedTimezoneMonth = {
      value: selectedMonth.value,
      label: moment
        .utc(selectedDate)
        .month(selectedMonth.value)
        .utcOffset(timezone)
        .format('MMMM'),
    };

    const selectedTimezoneDay = {
      value: selectedDay.value,
      label: moment
        .utc(selectedDate)
        .date(selectedDay.value)
        .utcOffset(timezone)
        .format('DD'),
    };

    // Selected comparing date values
    const selectedComparingTimezoneMonth = selectedComparingMonth
      && {
        value: selectedComparingMonth.value,
        label: moment
          .utc(selectedComparingDate)
          .month(selectedComparingMonth.value)
          .utcOffset(timezone)
          .format('MMMM'),
      };
    const selectedComparingTimezoneDay = selectedComparingDay
      && {
        value: selectedComparingDay.value,
        label: moment
          .utc(selectedComparingDate)
          .date(selectedComparingDay.value)
          .utcOffset(timezone)
          .format('DD'),
      };

    const selectedComparingTimezoneHour = selectedComparingHour
      && {
        value: selectedComparingHour.value,
        label: moment
          .utc(selectedComparingDate)
          .hour(selectedComparingHour.value)
          .utcOffset(timezone)
          .format('HH:mm'),
      };

    const monthsOptions = months.map(m => ({
      value: m.value,
      label: moment
        .utc(selectedDate)
        .date(m.value)
        .utcOffset(timezone)
        .format('MMMM'),
    }));
    const daysOptions = days.map(d => ({
      value: d.value,
      label: moment
        .utc(selectedDate)
        .date(d.value)
        .utcOffset(timezone)
        .format('DD'),
    }));
    const hoursOptions = hours.map(h => ({
      value: h.value,
      label: moment
        .utc(selectedDate)
        .hour(h.value)
        .utcOffset(timezone)
        .format('HH:00'),
    }));
    const comparingMonthsOptions = comparingMonths.map(d => ({
      value: d.value,
      label: moment
        .utc(selectedComparingDate)
        .date(d.value)
        .utcOffset(timezone)
        .format('MMMM'),
    }));
    const comparingDaysOptions = comparingDays.map(d => ({
      value: d.value,
      label: moment
        .utc(selectedComparingDate)
        .date(d.value)
        .utcOffset(timezone)
        .format('DD'),
    }));
    const comparingHoursOptions = comparingHours.map(h => ({
      value: h.value,
      label: moment
        .utc(selectedComparingDate)
        .hour(h.value)
        .utcOffset(timezone)
        .format('HH:00'),
    }));

    return (

      <div className="c-retina-bottom-bar">
        <div className="date-selectors">
          {monthsOptions.length > 1 &&
            <Select
              classNamePrefix="react-select"
              placeholder="Month"
              options={monthsOptions}
              value={selectedTimezoneMonth}
              menuPlacement="top"
              onChange={this.onChangeMonth}
            />
          }
          {monthsOptions.length === 1 &&
            <span>{monthsOptions[0].label}</span>
          }

          <Select
            classNamePrefix="react-select"
            placeholder="Day"
            options={daysOptions}
            value={selectedTimezoneDay}
            menuPlacement="top"
            onChange={this.onChangeDay}
          />
          <Select
            classNamePrefix="react-select"
            placeholder="Hour"
            options={hoursOptions}
            value={selectedTimezoneHour}
            menuPlacement="top"
            onChange={this.onChangeHour}
          />
        </div>
        {compareDates && (
        <div
          className={classnames({
            'compare-date-selectors': true,
            '-opened': comparing,
          })}
        >
          {
            comparing && (
              <React.Fragment>
                {
                  typeof selectedComparingTimezoneMonth !== 'undefined'
                  && (
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Month"
                      options={comparingMonthsOptions}
                      value={selectedComparingTimezoneMonth}
                      menuPlacement="top"
                      onChange={this.onChangeComparingMonth}
                    />
                  )
                }
                {
                  selectedComparingTimezoneDay
                  && (
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Day"
                      options={comparingDaysOptions}
                      value={selectedComparingTimezoneDay}
                      menuPlacement="top"
                      onChange={this.onChangeComparingDay}
                    />
                  )
                }
                {
                  typeof selectedComparingTimezoneHour !== 'undefined'
                  && (
                    <Select
                      classNamePrefix="react-select"
                      placeholder="Hour"
                      options={comparingHoursOptions}
                      value={selectedComparingTimezoneHour}
                      menuPlacement="top"
                      onChange={this.onChangeComparingHour}

                    />
                  )
                }
              </React.Fragment>
            )
          }
        </div>
        )}
      </div>
    );
  }
}

const optionPropType = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
});

BottomBar.propTypes = {
  // Month options for the selector
  months: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected month option
  selectedMonth: optionPropType,
  // Selected month depending on timezone
  selectedTimezoneMonth: optionPropType,
  // Day options for the selector
  days: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected day option
  selectedDay: optionPropType,
  // Selected day depending on timezone
  selectedTimezoneDay: optionPropType,
  // Hour options for the selector
  hours: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected hour option
  selectedHour: optionPropType,
  // Comparing month options for the selector
  comparingMonths: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected comparing month option
  selectedComparingMonth: optionPropType,
  // Comparing day options for the selector
  comparingDays: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected comparing day option
  selectedComparingDay: optionPropType,
  // Comparing hour options for the selector
  comparingHours: PropTypes.arrayOf(optionPropType).isRequired,
  // Selected comparing hour option
  selectedComparingHour: optionPropType,
  // Whether we're comparing dates
  comparing: PropTypes.bool.isRequired,
  // Set the selected month
  setMonth: PropTypes.func.isRequired,
  // Set the selected comparing month
  setComparingMonth: PropTypes.func.isRequired,
  // Set the selected day
  setDay: PropTypes.func.isRequired,
  // Set the selected comparing day
  setComparingDay: PropTypes.func.isRequired,
  // Set the selected hour
  setHour: PropTypes.func.isRequired,
  // Set the selected comparing hour
  setComparingHour: PropTypes.func.isRequired,
  // Toggle the comparison mode
  toggleComparing: PropTypes.func.isRequired,
  // Language options for the selector
  languages: PropTypes.arrayOf(optionPropType).isRequired,
};

BottomBar.defaultProps = {
  selectedMonth: null,
  selectedComparingMonth: null,
  selectedDay: null,
  selectedComparingDay: null,
  selectedHour: null,
  selectedComparingHour: null,
  selectedTimezoneDay: null,
  selectedTimezoneMonth: null,
  selectedTimezoneHour: null,
};

export default BottomBar;



// WEBPACK FOOTER //
// ./src/components/retina-demo/components/bottom-bar/component.js